import React, { useState } from 'react';

import { TextField, InputAdornment, IconButton } from '@mui/material';

import { ReactComponent as CloseIcon } from '../assets/icons/close_icon.svg';
import { ReactComponent as SearchIcon } from '../assets/icons/search_icon.svg';

type Props = {
  handleClear: () => void;
  handleSearch: (text: string) => void;
  placeholder: string;
};

const SearchBar: React.FC<Props> = ({
  handleClear,
  handleSearch,
  placeholder,
}) => {
  const [searchValue, setSearchValue] = useState('');

  const handleSearchInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchValue(event.target.value);
  };

  const handleTappedClear = () => {
    setSearchValue('');
    handleClear();
  };

  const onKeyUp = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.code === 'Enter') {
      handleSearch(searchValue);
    }
  };

  return (
    <TextField
      onKeyUp={onKeyUp}
      placeholder={placeholder}
      size='small'
      value={searchValue}
      color='primary'
      onChange={handleSearchInputChange}
      sx={{
        backgroundColor: '#fff',
        borderColor: 'divider.main',
        minWidth: 275,
        [`& fieldset`]: {
          borderRadius: '16px',
        },
      }}
      InputProps={{
        style: {
          height: 50,
        },
        startAdornment: (
          <InputAdornment position='start'>
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment:
          searchValue.length !== 0 ? (
            <InputAdornment position='end'>
              <IconButton onClick={() => handleTappedClear()}>
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          ) : undefined,
      }}
    />
  );
};

export default SearchBar;
